import { createSelector } from 'reselect'

import { selectStrategicInitiativesState } from './selectStrategicInitiativesState'

export const selectStrategicInitiativesKeyObjectives = createSelector(
  [selectStrategicInitiativesState],
  (state) => state.keyObjectives
)
